import * as React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { Col, Row, Glyphicon, Alert } from "react-bootstrap";
import { REQUEST } from "src/co/sura/config/ajax-wrapper";
import { Form } from "react-final-form";
import { Mensaje } from "../../../general/componentes/Mensaje";
import { DotLoader } from "react-spinners";
import TextoInput from "../../../general/componentes/TextoInput";
import TextoInputSelector from "../../../general/componentes/TextoInputSelector";
import { ComplementosFecha } from "../../config_general/modelo/ComplementosFecha";
import DatePickerSura from "../../../general/componentes/DatePicker";
import { FiltroAdminGlosas, Glosa } from "../modelo/AdminGlosas";
import { consultarGlosasSAT, limpiarMensajesGlosas, ventanaAyudaGlosa } from "../modulos/adminGlosaActions";
import TablaAdminGlosas from "./TablaAdminGlosas";
import { TipoFechaGlosa } from "../modelo/TipoFechaGlosa";
import TiposGestion from "../../inconsistencias/componentes/TiposGestion";
import InterruptorSN from "../../config_general/componentes/InterruptorSN";
import CheckBoxEnvio from "../../config_general/componentes/CheckBoxEnvio";
import ConsultarReporteXLS from "../../descarga_reporte/componentes/ConsultarReporteXLS";
import { TipoReportes } from "../../descarga_reporte/modelo/TiposReporte";
import { descargarReporteXLS } from "../../descarga_reporte/modulos/descargaReporteActions";
import TiposTransacciones from "../../../general/componentes/TiposTransacciones";
import { consultarMaestroTransaccionesSat } from "../../../general/modulos/maestrosActions";
import TextoAyuda from "../../config_general/componentes/TextoAyuda";
import { servicio, codigoGlosa, coincidenciaGlosa, tipoGestion, tipoFecha, fechaRegistro, complementoFecha, esBloqueante } from "../../config_general/modelo/TextosAyuda";
import ModalAyudaVentana from "../../config_general/componentes/ModalAyudaVentana";
import { tituloVentanaGlosas } from "../../config_general/modelo/TextoVentanaAyuda";

class AdministradorGlosas extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            ventanaAyuda: true,
            showAlert: true
        };
    }

    componentWillMount() {
        if (!this.props.transaccionesSat || this.props.transaccionesSat.length === 0) {
            this.props.dispatch(consultarMaestroTransaccionesSat());
        }

        const ventanaDesplegada = this.props.ventanaAyudaGlosa;
        ventanaDesplegada ? this.setState({ ventanaAyuda: false }) : this.props.dispatch(ventanaAyudaGlosa());
    }

    handleDismissAlert() {
        this.setState({ showAlert: false });
    }

    componentWillReceiveProps(nextProps: any) {
        this.setState({ showAlert: nextProps.showAlert });
    }

    componentWillUnmount() {
        this.props.dispatch(limpiarMensajesGlosas());
    }

    render() {
        const { glosas, estado, estadoAccion, mensajeAccion, paginas, tamanoPagina, paginaActual } = this.props;

        return (
            <div>
                <Row>
                    {this.crearVentanaAyuda()}
                    <Form
                        onSubmit={this.onSubmit}
                        validate={this.validate}
                        render={({ handleSubmit, invalid, errors, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <h1 className={"title"}>Administración Glosas
                                    <button type="button" className="btns btns-glyphicon" onClick={this.actualizarModalAyuda}
                                        disabled={this.state.ventanaAyuda}>
                                        <span className="icons-table">
                                            <Glyphicon style={{ left: `10px` }} glyph="question-sign" />
                                        </span>
                                    </button>
                                </h1>
                                <div className={"card"}>
                                    <div className={"card-header"}>
                                        <h3 className={"panel-title"}>Filtros consulta de glosas</h3>
                                    </div>
                                    <div className={"card-body"}>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="servicio">Servicio</label>
                                                <TextoAyuda texto={servicio} />
                                                <TiposTransacciones name="servicio" placeholder="Ingrese numero servicio" />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="codigoGlosa">Código Glosa</label>
                                                <TextoAyuda texto={codigoGlosa} />
                                                <TextoInput name="codigoGlosa" placeholder="Ingrese codigo" maxLength={5} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="palabraClave">Texto Coincidencia</label>
                                                <TextoAyuda texto={coincidenciaGlosa} />
                                                <TextoInput name="palabraClave" placeholder="Ingrese texto" maxLength={10} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="tipoGestion">Tipo Gestión</label>
                                                <TextoAyuda texto={tipoGestion} />
                                                <TiposGestion name={"tipoGestion"} />
                                            </Col>
                                        </Row>
                                        <Row className={"form-group"}>
                                            <Col sm={3}>
                                                <label htmlFor="tipoFecha">Tipo Fecha</label>
                                                <TextoAyuda texto={tipoFecha} />
                                                <TextoInputSelector name="tipoFecha" maestro={this.listaTipoFechaGlosa()} />
                                                {errors.tipoFecha &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.tipoFecha}</span>
                                                    </div>
                                                }
                                            </Col>
                                            <Col sm={3}>
                                                <label>Fecha Registro</label>
                                                <TextoAyuda texto={fechaRegistro} />
                                                <DatePickerSura name={"fecha"} />
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="complementoFecha">Complemento Fecha</label>
                                                <TextoAyuda texto={complementoFecha} />
                                                <TextoInputSelector name="complementoFecha" maestro={this.listarSignoFechas()} />
                                                {errors.complementoFecha &&
                                                    <div style={{ marginTop: '5px' }}>
                                                        <span className={"text-danger"}>{errors.complementoFecha}</span>
                                                    </div>
                                                }
                                            </Col>
                                            <Col sm={3}>
                                                <label htmlFor="snBloqueante">Es Bloqueante</label>
                                                <TextoAyuda texto={esBloqueante} />
                                                <Row className={"form-group"}>
                                                    <Col sm={2}>
                                                        <CheckBoxEnvio name={"envioSNBloqueante"} />
                                                    </Col>
                                                    <Col sm={8} style={{ paddingLeft: "6px" }}>
                                                        <InterruptorSN name={"snBloqueante"} />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <div style={{ marginTop: `25px` }}>
                                            <Row className={"form-group"}>
                                                <Col sm={2}>
                                                    <ConsultarReporteXLS tipoReporte={TipoReportes.CATALOGO_GLOSAS} onDescargar={this.descargarXLS} />
                                                </Col>
                                                <Col smOffset={6} sm={1}>
                                                    <button type="button" className="btns btns-link" onClick={form.reset}
                                                        disabled={submitting || pristine}>
                                                        Limpiar
                                                    </button>
                                                </Col>
                                                <Col sm={2}>
                                                    <button type="submit" className="btns btns-primary" disabled={submitting || invalid}>
                                                        <b>Consultar</b> &nbsp;<Glyphicon className={"search"} glyph={"search"} />
                                                    </button>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        )}
                    />
                </Row>
                <Row>
                    {this.renderAlertaAccion(estadoAccion, mensajeAccion)}
                    {this.renderTablaAdminGlosas(glosas, estado, paginas, tamanoPagina, paginaActual)}
                </Row>
            </div>
        );
    }

    renderAlertaAccion(estadoAccion: REQUEST, mensajeAccion: string) {
        switch (estadoAccion) {
            case REQUEST.SUCCESS:
                return this.state.showAlert && this.renderAlertaExito();
            case REQUEST.ERROR:
                return this.state.showAlert && this.renderAlertaError(mensajeAccion);
            default:
                return false;
        }
    }

    renderAlertaError(mensajeAccion: string) {
        return (
            <Alert bsStyle="danger" onDismiss={() => this.handleDismissAlert()}>
                <h4>ERROR !</h4>
                <p style={{ fontSize: "15px", color: "#a94442" }}>
                    Ocurrió un error realizando la acción. <b>Error:</b> {mensajeAccion}.
                </p>
            </Alert>
        );
    }

    renderAlertaExito() {
        return (
            <Alert bsStyle="success" onDismiss={() => this.handleDismissAlert()}>
                <h4>EXITO !</h4>
                <p style={{ fontSize: "15px" }}>
                    La acción se realizó con éxito.
                </p>
            </Alert>
        );
    }

    renderTablaAdminGlosas(glosas: Array<Glosa>, estado: REQUEST, paginas: number, tamanoPagina: number, paginaActual: number) {
        switch (estado) {
            case REQUEST.ERROR:
                return <Mensaje type={"danger"} mensaje={"Se ha presentado un error, intenta nuevamente!"} />;
            case REQUEST.PENDING:
                return <DotLoader size={25} />;
            case REQUEST.SUCCESS:
                if (!glosas || !glosas.length)
                    return (
                        <span>
                            <Mensaje type={"info"} mensaje={"No se han encontrado glosas"} />
                        </span>
                    );
                else
                    return (
                        <span>
                            <TablaAdminGlosas
                                glosas={glosas}
                                filtro={this.filtros()}
                                paginas={paginas}
                                tamanoPagina={tamanoPagina}
                                paginaActual={paginaActual}
                                consultaPaginada={this.consultaPaginada}
                            />
                        </span>
                    );
            default:
                return false;
        }
    }

    crearVentanaAyuda = () => {
        return (
            <ModalAyudaVentana
                titulo={tituloVentanaGlosas}
                visible={this.state.ventanaAyuda}
                onCancelar={this.actualizarModalAyuda}
            >
                <p style={{ color: "#000000" }}>Por medio de esta ventana podrás consultar o exportar a un archivo de Excel las Glosas existentes,
                    luego de consultarlas se tiene la opción de crear o actualizar una glosa,
                    opciones que se encuentran en la columna de Acción.
                    <br />
                    <br />
                    Es <strong style={{ color: "#e57777" }}>importante</strong> antes de realizar cualquier modificación a una glosa tener en cuenta que 
                    esta cumple una función dentro de la aplicación lo que podría llevar a la generación de errores, desconfiguración o comportamiento
                    inesperado de la aplicación.
                    <br />
                    <br />
                    Se recomienda antes de modificarlos consultar con TI el impacto de cambiar la glosa o sus valores.
                </p>
            </ModalAyudaVentana >
        );
    }

    actualizarModalAyuda = () => {
        this.setState({ ventanaAyuda: !this.state.ventanaAyuda });
    }

    filtros(): FiltroAdminGlosas {
        return {
            servicio: this.state.servicio,
            codigoGlosa: this.state.codigoGlosa,
            palabraClave: this.state.palabraClave,
            tipoGestion: this.state.tipoGestion,
            tipoFecha: this.state.tipoFecha,
            fecha: this.state.fecha,
            complementoFecha: this.state.complementoFecha,
            snBloqueante: this.state.snBloqueante,
        };
    }

    consultaPaginada = (filtro: FiltroAdminGlosas) => {
        this.props.dispatch(consultarGlosasSAT(filtro));
    };

    onSubmit = (values: any) => {
        const servicio = values.servicio ? Number(values.servicio) : undefined;
        const codigoGlosa = values.codigoGlosa ? values.codigoGlosa.valueOf() : undefined;
        const palabraClave = values.palabraClave ? values.palabraClave.valueOf() : undefined;
        const tipoGestion = values.tipoGestion ? values.tipoGestion.valueOf() : undefined;
        const tipoFecha = values.tipoFecha ? values.tipoFecha.value : undefined;
        const fecha = values.fecha ? values.fecha.valueOf() : undefined;
        const complementoFecha = values.complementoFecha ? Number(values.complementoFecha.value) : undefined;
        const envioSNBloqueante = values.envioSNBloqueante;

        const snBloqueante = () => {
            if (envioSNBloqueante) return values.snBloqueante ? "S" : "N";
            return undefined;
        };

        const filtro: FiltroAdminGlosas = {
            servicio: servicio,
            codigoGlosa: codigoGlosa,
            palabraClave: palabraClave,
            tipoGestion: tipoGestion,
            tipoFecha: tipoFecha,
            fecha: fecha,
            complementoFecha: complementoFecha,
            snBloqueante: snBloqueante(),
            tamanoPagina: this.props.tamanoPagina,
            paginaActual: 0
        };

        this.setState({
            servicio: servicio,
            codigoGlosa: codigoGlosa,
            palabraClave: palabraClave,
            tipoGestion: tipoGestion,
            tipoFecha: tipoFecha,
            fecha: fecha,
            complementoFecha: complementoFecha,
            snBloqueante: snBloqueante(),
            filtro: filtro
        });

        this.props.dispatch(consultarGlosasSAT(filtro));
    };

    validate = (values: any) => {
        const errors = {
            tipoFecha: undefined,
            fecha: undefined,
            complementoFecha: undefined
        };

        if (values.tipoFecha || values.fecha || values.complementoFecha) {
            errors.tipoFecha = values.tipoFecha ? undefined : "Por favor seleccione el tipo";
            errors.fecha = values.fecha ? undefined : "Por favor seleccione la fecha";
            errors.complementoFecha = values.complementoFecha ? undefined : "Por favor una de las opciones";
        }

        return errors;
    };

    listarSignoFechas = () => {
        return [].concat(
            ComplementosFecha.map(value => ({
                value: value.codigo,
                label: value.nombre
            })
            ));
    }

    listaTipoFechaGlosa = () => {
        return [].concat(
            TipoFechaGlosa.map(value => ({
                value: value.nombreEnvio,
                label: value.nombreProceso
            })
            ));
    }

    descargarXLS = (tipo: TipoReportes) => {
        this.props.dispatch(descargarReporteXLS(tipo));
    }
}

export default connect((store: any) => {
    return {
        dniUsuarioGestionLogin: R.pathOr(undefined, ["inicio", "dniLogin"])(store),
        transaccionesSat: R.pathOr([], ["maestros", "transaccionesSat"])(store),
        estado: R.pathOr([], ["administrador_glosas", "estado"])(store),
        estadoAccion: R.pathOr([], ["administrador_glosas", "estadoAccion"])(store),
        mensajeAccion: R.pathOr([], ["administrador_glosas", "mensajeAccion"])(store),
        showAlert: R.pathOr([], ["administrador_glosas", "showAlert"])(store),
        glosas: R.pathOr([], ["administrador_glosas", "glosas"])(store),
        paginas: R.pathOr([], ["administrador_glosas", "paginas"])(store),
        paginaActual: R.pathOr([], ["administrador_glosas", "paginaActual"])(store),
        tamanoPagina: R.pathOr([], ["administrador_glosas", "tamanoPagina"])(store),
        totalGlosasConsulta: R.pathOr([], ["administrador_glosas", "totalGlosasConsulta"])(store),
        ventanaAyudaGlosa: R.pathOr(undefined, ["administrador_glosas", "ventanaAyudaGlosa"])(store)
    };
})(AdministradorGlosas);


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_glosas/componentes/AdministradorGlosas.tsx